import { render, staticRenderFns } from "./ScreenAnchor3dScene.vue?vue&type=template&id=60638542&scoped=true&"
import script from "./ScreenAnchor3dScene.vue?vue&type=script&lang=js&"
export * from "./ScreenAnchor3dScene.vue?vue&type=script&lang=js&"
import style0 from "./ScreenAnchor3dScene.vue?vue&type=style&index=0&id=60638542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60638542",
  null
  
)

export default component.exports